import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavMenuItem} from '../../models/nav-menu-item.interface';
import {MatDialog} from '@angular/material/dialog';
import {ChangePasswordDialogComponent} from '../change-password-dialog/change-password-dialog.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './app-toolbar.component.html',
  styleUrls: ['./app-toolbar.component.scss']
})
export class AppToolbarComponent implements OnInit {


  @Input()
  userName!: string;
  @Input()
  system!: string;
  @Input()
  country!: string;
  @Input()
  allMenuItems!: NavMenuItem[];
  @Input()
  userRoles?: string[];
  @Output()
  loadBreadcrumb: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  logout: EventEmitter<void> = new EventEmitter();

  menuItemsByRole!: NavMenuItem[];
  toolbarMenuVisible = false;
  selectedMenu?: NavMenuItem;
  submenus: NavMenuItem[] = [];
  mobileToolbarOpen = false;

  constructor(private readonly dialog: MatDialog,
    private authService: AuthService,) {
  }

  ngOnInit(): void {
    const menuByRoles = [] as NavMenuItem[];
    this.allMenuItems.forEach(
      item => {
        if (!item.roles || this.userHasAnyRole(item.roles)) {
          const itemByRoles = {...item};
          itemByRoles.submenus = this.filterByRole(item.submenus);
          
          if (this.authService.getUserRoles()?.includes('WF_ADMIN') && itemByRoles.title == 'INTELLIGENCE CHARTS' && !itemByRoles.submenus[0].code.includes('admin')) {
            itemByRoles.submenus.forEach(item => {
              item.code = item.code + 'admin';
              item.link = item.link + 'admin';
              item.submenus?.forEach(item2 => {
                let splitLink = item2.link.split('/');
                item2.link = splitLink[0] + '/' + splitLink[1] + 'admin/' + splitLink[2];
              });
            });
          }
          if (!this.authService.getUserRoles()?.includes('WF_ADMIN') && 
          itemByRoles.title == 'INTELLIGENCE CHARTS' && 
          itemByRoles.submenus[0].code.includes('admin')) {
            itemByRoles.submenus.forEach(item => {
              item.code = item.code.slice(0, -5);
              item.link = item.link.slice(0, -5);
              item.submenus?.forEach(item2 => {
                let splitLink = item2.link.split('/');
                item2.link = splitLink[0] + '/' + splitLink[1].slice(0, -5) + '/' + splitLink[2];
              });
            });
          }
          menuByRoles.push(itemByRoles);
        }
      }
    );
    this.menuItemsByRole = menuByRoles;

  }

  onMouseOver(item: NavMenuItem): void {
    if (item?.submenus) {
      this.selectedMenu = item;
      this.submenus = item.submenus;
      this.toolbarMenuVisible = true;
    } else {
      this.submenus = [];
    }
  }

  onMobileMenuSelected(item: NavMenuItem): void {
    if (item?.submenus) {
      this.selectedMenu = item;
      this.submenus = item.submenus;
    } else {
      this.submenus = [];
    }
  }

  onMouseOut(): void {
    this.toolbarMenuVisible = false;
    this.selectedMenu = undefined;
    this.submenus = [];
  }

  loadLateralMenu(item: NavMenuItem): void {
    this.loadBreadcrumb.emit('/' + this.selectedMenu?.link + '/' + item.link);
  }

  doLogout(): void {
    this.logout.emit();
  }

  private userHasAnyRole(roles: string[]): boolean {
    let userHasRole = false;
    roles.forEach(role => {
      if (this.userRoles && this.userRoles.includes(role)) {
        userHasRole = true;
      }
    });
    return userHasRole;
  }

  private filterByRole(options: NavMenuItem[] | undefined): NavMenuItem[] {
    if (!options) {
      return [];
    }
    return options.filter(option => !option?.roles || this.userHasAnyRole(option.roles));
  }

  changePassord(): void {
    this.dialog.open(ChangePasswordDialogComponent);
  }
}
